import { Serializable } from '../../common/types'
import { Checklist, ChecklistType } from 'src/app/checklists'
import { VehicleState } from '../../@store/reducers/flight-network.reducer'
import { VehicleStatus } from '../../common/jrpc.service'

export class Vehicle extends Serializable<Vehicle> implements VehicleState {
  id: number | null = null
  name: string | null = null
  registration_number?: string | null = null
  center_id: number | null = null
  center_name?: string
  is_in_service: boolean | null = null
  is_parked: boolean | null = null
  checklists: { checklist: Checklist }[] | null = null

  day_open_checklist: Checklist
  day_close_checklist: Checklist
  preflight_checklist: Checklist
  postflight_checklist: Checklist

  simulation_status?: string
  status?: VehicleStatus | ''

  // TODO: remove Omit, which is a workaround for conflicting types of Checklists vs ChecklistsState
  constructor(details: Omit<Partial<Vehicle>, 'checklists'>) {
    super()
    // deserialize object data from json
    this.checkAndDeserialize(details)

    // Init class params
    this.initParams()
  }

  /**
   *  Initialize class properties
   */
  initParams(): void {
    for (const { checklist } of this.checklists) {
      switch (checklist.checklist_type) {
        case ChecklistType.VehicleDayOpen:
          this.day_open_checklist = checklist
          break

        case ChecklistType.VehicleDayClose:
          this.day_close_checklist = checklist
          break

        case ChecklistType.VehiclePreFlight:
          this.preflight_checklist = checklist
          break

        case ChecklistType.VehiclePostFlight:
          this.postflight_checklist = checklist
          break

        default:
          break
      }
    }
  }

  deserialize(details: Partial<Vehicle>): void {
    this.id = details['id']
    this.name = details['name']
    this.registration_number = details['registration_number']
    this.center_id = details['center_id']
    this.center_name = details['center_name']
    this.is_in_service = details['is_in_service']
    this.is_parked = details['is_parked']
    this.simulation_status = details['simulation_status']
    this.status = details['status']
    this.checklists = (details['checklists'] ?? []).map((item) => ({ checklist: new Checklist(item.checklist) }))
  }

  toJSON(): VehicleState {
    return {
      id: this.id,
      name: this.name,
      registration_number: this.registration_number,
      center_id: this.center_id,
      is_in_service: this.is_in_service,
      is_parked: this.is_parked,
      checklists: this.checklists.map((item) => ({ checklist: item.checklist.toJSON() })),
    }
  }
}
